import React, {useState} from 'react';
import {v4 as uuid} from 'uuid';
import styled from 'styled-components';
import OuterLink from './OuterLink';
import Img from './Img';
import {MenuItemStyles} from '../styles';
import ScrollLink from './ScrollLink';
import {menu} from '../data';
import {breakPoint, headerBreakPoint} from '../styles/var';
import clsx from 'clsx';
import BurgerButton from './BurgerButton';

// images
import logo from '../assets/img/PC1-1.png';
import img_more from '../assets/img/expand_more_black_24dp.svg';



const HeaderStyles = styled.header`
  --bg: var(--white);
  background-color: var(--bg);
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: var(--level1);
  .menu-btn {
    position: fixed;
    z-index: var(--level1);
  }
  @media (min-width: ${headerBreakPoint.min}) {
    .menu-btn {
      display: none;
    }
  }
  @media (max-width: ${headerBreakPoint.max}) {
    .menu-btn {
      top: 1.5rem;
      right: 2rem;
    }
    .logo {
      max-width: 21rem;
    }
  }
  @media (max-width: ${breakPoint.smMax}) {
    .menu-btn {
      top: 0;
      right: 0;
    }
    .logo {
      max-width: 14rem;
    }
  }
`
const MainMenuStyles = styled.div`
  width: 100%;
  .menu-wrap {
    .link {
      border: 1px solid transparent;
      background-color: var(--bg);
    }
  }
  @media (min-width: ${headerBreakPoint.min}) {
    .menu-wrap {
      gap: 1.5rem;
      margin-right: 3rem;
      .link {
        border-color: var(--black);
        padding: 0.4rem 0.8rem;
        &:hover, &.active {
          --bg: var(--primary);
          border-color: transparent;
        }
      }
    }
  }
  @media (min-width: ${breakPoint.lgMin}) {
    .menu-wrap {
      gap: 4rem;
      margin-right: 6rem;
      .link {
        padding: .6rem 1rem;
      }
    }
  }
  @media (max-width: ${headerBreakPoint.max}) {
    --bg: var(--grey);
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: var(--level1);
    place-content: center;
    background-color: var(--bg);
    &.show {
      display: grid;
    }
    .menu-wrap {
      --bg: var(--white);
      flex-direction: column;
      flex-wrap: nowrap;
      align-items: center;
      padding: 2.5rem;
      border: 1px solid var(--secondary);
      background-color: var(--bg);
      & .link-item {
        width: 100%;
        &:not(:last-child) {
          margin-bottom: 1.5rem;
        }
        &:nth-child(odd) {
          & .link {
            --bg: var(--primary);
          }
        }

        &:nth-child(even) {
          & .link {
            --bg: var(--grey);
            color: var(--black);
          }
        }
      }

      & .link {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 2rem;
        padding-left: 2rem;

        &::after {
          content: '';
          display: inline-block;
          width: 2rem;
          height: 2rem;
          background: url(${img_more}) no-repeat center center / cover;
          margin-left: .8rem;
        }
      }
    }
  }
`

const Header = () => {
  const [isShow, setIsShow] = useState(false);
  const handleClick = () => {
    setIsShow(prev => !prev);
  }
  const handleClose = () => {
    setIsShow(false);
  }
  return (
    <HeaderStyles>
      <OuterLink href="https://www.mombaby.com.tw/" title="Mombaby 媽媽寶寶懷孕生活網">
        <Img src={logo} auto wrapProps={{className: "logo"}}/>
      </OuterLink>
      <MainMenuStyles id="menu" className={clsx('animate__faster', {show: isShow, animate__animated: isShow, animate__pulse: isShow})}>
        <MenuItemStyles justifyContent="flex-end" className='menu-wrap'>
          {menu.map(({text, to}) => (
            <li key={uuid()} className="link-item">
              <ScrollLink className="link" to={to} onClick={handleClose}>{text}</ScrollLink>
            </li>
          ))}
        </MenuItemStyles>
      </MainMenuStyles>
      <BurgerButton className="menu-btn" onClick={handleClick}/>
    </HeaderStyles>
  )
}

export default Header;
